export default "__VITE_ASSET__DJwFLued__"